import angular from 'angular'
import StoryNotFoundComponent from './storyNotFound.component'
import StoryNotFoundController from './storyNotFound.controller'

export default angular
  .module('ellipsis.storyNotFound', [])
  .component('storyNotFound', StoryNotFoundComponent)
  .controller('StoryNotFoundController', StoryNotFoundController)
